<p-dialog [(visible)]="displayAddView" [modal]="true" [closable]="false" [responsive]="true"
[style]="{width: '85vw'}">
    <ng-template pTemplate="header">
        <div style="display: flex; justify-content: space-between; width: 100%;">
            <h5 class="p-mb-0">
                {{ isAdd ? 'Add New Account' : (isCopyAccount ? 'Copy Account' : 'View Account') }}
            </h5>
            <button pButton pRipple (click)="closeModal.emit();displayAddView=false"
                class="p-button-text p-button-rounded p-pt-0" icon="pi pi-times"></button>
        </div>
    </ng-template>
    <div *ngIf="templateSections.length; else elseBlock">
        <div>
            <form [formGroup]="accountForm">
                <div class="header">
                    <h5>
                        {{ templateSections && templateSections[0]?.name }}
                    </h5>
                </div>
                <div class="card">
                    <div *ngIf="isAdd || isEdit || isCopyAccount">
                        <div class="p-field p-grid">
                            <div class="p-col-12 p-lg-2" *ngIf="checkedFields.Title">
                                <label class="p-mb-2">
                                    {{ checkedFields.Title?.labelName }}
                                </label>
                                <p-dropdown [options]="salutations" formControlName="contactSalutationId"
                                    optionLabel="name" placeholder="Select Title..." [filter]="true" [filterBy]="'name'"
                                    appendTo="body">
                                </p-dropdown>
                            </div>

                            <div class="p-col-12 p-formgrid p-lg-4" *ngIf="checkedFields.FirstName">
                                <label class="p-mb-2">
                                    {{ checkedFields.FirstName?.labelName }}
                                    <span style="color: red;"> * </span>
                                </label>
                                <input pInputText type="text" formControlName="contactFirstName" pattern="^[^:]*$" />
                                <div *ngIf="isTouched('contactFirstName')">
                                    <div class="p-mt-1" *ngIf="hasRequiredError('contactFirstName')">
                                        <small class="p-invalid">
                                            {{ checkedFields.FirstName?.labelName }} is required
                                        </small>
                                    </div>
                                </div>
                                <div class="p-mt-1"
                                    *ngIf="hasValue('contactFirstName') && hasLengthError('contactFirstName')">
                                    <small class="p-invalid">
                                        {{ checkedFields.FirstName?.labelName }} can not be empty.
                                    </small>
                                </div>
                                <div class="p-mt-1" *ngIf="hasMaxLengthError('contactFirstName')">
                                    <small class="p-invalid">
                                        Max 100 characters
                                    </small>
                                </div>
                                <div class="p-mt-1" *ngIf="hasPatternError('contactFirstName')">
                                    <small class="p-invalid">
                                        Colon (:) is not allowed
                                    </small>
                                </div>
                            </div>

                            <div class="p-col-12 p-lg-2" *ngIf="checkedFields.MiddleInitial">
                                <label class="p-mb-2">
                                    {{ checkedFields.MiddleInitial?.labelName }}
                                </label>
                                <input pInputText type="text" formControlName="contactMiddleName" pattern="^[^:]*$" />
                                <div class="p-mt-1" *ngIf="hasMaxLengthError('contactMiddleName')">
                                    <small class="p-invalid">
                                        Max 100 characters
                                    </small>
                                </div>
                                <div class="p-mt-1" *ngIf="hasPatternError('contactMiddleName')">
                                    <small class="p-invalid">
                                        Colon (:) is not allowed
                                    </small>
                                </div>
                            </div>

                            <div class="p-col-12 p-lg-4" *ngIf="checkedFields.LastName">
                                <label class="p-mb-2">
                                    {{ checkedFields.LastName?.labelName }}
                                </label>
                                <input pInputText type="text" formControlName="contactLastName" pattern="^[^:]*$" />
                                <div class="p-mt-1" *ngIf="hasMaxLengthError('contactLastName')">
                                    <small class="p-invalid">
                                        Max 100 characters
                                    </small>
                                </div>
                                <div class="p-mt-1" *ngIf="hasPatternError('contactLastName')">
                                    <small class="p-invalid">
                                        Colon (:) is not allowed
                                    </small>
                                </div>
                            </div>
                        </div>

                        <div class="p-field p-formgrid p-grid multiline">
                            <div class="p-col-12 p-lg-6" *ngIf="checkedFields.WorkEmail || checkedFields.HomeEmail ||
                                checkedFields.CE1 || checkedFields.CE2">
                                <label class="p-mt-0">
                                    Email
                                </label>

                                <div class="p-col-12 p-px-0" *ngIf="checkedFields.WorkEmail">
                                    <span class="p-input-icon-left w-100 p-mb-3">
                                        <i [pTooltip]="checkedFields.WorkEmail?.labelName" tooltipPosition="top"
                                            class="pi pi-briefcase"></i>
                                        <input pInputText type="email" (input)="updateContactEmailPayload($event, 0)"
                                            formControlName="contactWorkEmail"
                                            pattern="[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$"
                                            (blur)="contactEmailCheck($event.target.value,'contactWorkEmail',0)" 
                                            placeholder="{{checkedFields.WorkEmail?.labelName}}" />
                                    </span>

                                    <div class="p-mb-3" *ngIf="isInvalid('contactWorkEmail')">
                                        <div *ngIf="hasMaxLengthError('contactWorkEmail')">
                                            <small class="p-invalid">
                                                Max 100 characters
                                            </small>
                                        </div>
                                        <div *ngIf="hasPatternError('contactWorkEmail')">
                                            <small class="p-invalid">
                                                Invalid email format
                                            </small>
                                        </div>
                                        <div *ngIf="hasEmailExistError('contactWorkEmail')">
                                            <small class="p-invalid">
                                                This email already added, please enter another email
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                <div class="p-col-12 p-px-0" *ngIf="checkedFields.HomeEmail">
                                    <span class="p-input-icon-left w-100 p-mb-3">
                                        <i [pTooltip]="checkedFields.HomeEmail?.labelName" tooltipPosition="top"
                                            class="pi pi-home"></i>
                                        <input pInputText type="email" (input)="updateContactEmailPayload($event, 1)"
                                            formControlName="contactHomeEmail"
                                            pattern="[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$"
                                            (blur)="contactEmailCheck($event.target.value,'contactHomeEmail',1)" 
                                            placeholder="{{checkedFields.HomeEmail?.labelName}}" />
                                    </span>

                                    <div class="p-mb-3" *ngIf="isInvalid('contactHomeEmail')">
                                        <div *ngIf="hasMaxLengthError('contactHomeEmail')">
                                            <small class="p-invalid">
                                                Max 100 characters
                                            </small>
                                        </div>
                                        <div *ngIf="hasPatternError('contactHomeEmail')">
                                            <small class="p-invalid">
                                                Invalid email format
                                            </small>
                                        </div>
                                        <div *ngIf="hasEmailExistError('contactHomeEmail')">
                                            <small class="p-invalid">
                                                This email already added, please enter another email
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                <div class="p-col-12 p-px-0" *ngIf="checkedFields.CE1">
                                    <span class="p-input-icon-left w-100 p-mb-3">
                                        <i [pTooltip]="checkedFields.CE1?.labelName" tooltipPosition="top"
                                            class="pi pi-envelope"></i>
                                        <input pInputText type="email" (input)="updateContactEmailPayload($event, 2)"
                                            formControlName="contactCE1Email"
                                            pattern="[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$"
                                            (blur)="contactEmailCheck($event.target.value,'contactCE1Email',2)" 
                                            placeholder="{{checkedFields.CE1?.labelName}}" />
                                    </span>

                                    <div class="p-mb-3" *ngIf="isInvalid('contactCE1Email')">
                                        <div *ngIf="hasMaxLengthError('contactCE1Email')">
                                            <small class="p-invalid">
                                                Max 100 characters
                                            </small>
                                        </div>
                                        <div *ngIf="hasPatternError('contactCE1Email')">
                                            <small class="p-invalid">
                                                Invalid email format
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                <div class="p-col-12 p-px-0" *ngIf="checkedFields.CE2">
                                    <span class="p-input-icon-left w-100 p-mb-3">
                                        <i [pTooltip]="checkedFields.CE2?.labelName" tooltipPosition="top"
                                            class="pi pi-envelope"></i>
                                        <input pInputText type="email" (input)="updateContactEmailPayload($event, 3)"
                                            formControlName="contactCE2Email"
                                            pattern="[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$"
                                            (blur)="contactEmailCheck($event.target.value,'contactCE2Email',3)" 
                                            placeholder="{{checkedFields.CE2?.labelName}}" />
                                    </span>

                                    <div class="p-mb-3" *ngIf="isInvalid('contactCE2Email')">
                                        <div *ngIf="hasMaxLengthError('contactCE2Email')">
                                            <small class="p-invalid">
                                                Max 100 characters
                                            </small>
                                        </div>
                                        <div *ngIf="hasPatternError('contactCE2Email')">
                                            <small class="p-invalid">
                                                Invalid email format
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="p-col-12 p-lg-6" *ngIf="checkedFields.WorkPhone || checkedFields.HomePhone ||
                            checkedFields.MobilePhone || checkedFields.CP1 || checkedFields.CP2">
                                <div class="p-inputgroup p-grid p-mb-2">
                                    <label class="p-col-4">
                                        Select Country
                                    </label>
                                    <label class="p-col-8" style="padding-left:0.75rem">
                                        Phone
                                    </label>
                                </div>
                                <div class="p-grid" *ngIf="checkedFields.WorkPhone">
                                    <div class="p-col-12 p-lg-4 ">
                                        <p-dropdown [options]="countryData" [filter]="true" filterBy="CountryName"
                                            optionLabel="CountryName"
                                            optionValue="CountryName"
                                            [autoDisplayFirst]="false"
                                            [(ngModel)]="contactPhones[0].country"
                                            [ngModelOptions]="{standalone: true}"
                                            placeholder="Select Country"
                                            (onChange)="updateContactPhoneCodePayload($event, 0)"
                                            class="inline" appendTo="body">
                                        </p-dropdown>
                                    </div>
                                    <div class="p-col-12 p-lg-8">
                                        <div class="p-inputgroup">
                                            <span class="p-inputgroup-addon">+{{ contactPhones[0].code }}</span>
                                            <p-inputMask
                                                *ngIf="phoneNumberFormat && !contactPhones[0]?.maskingDisabled"
                                                [mask]="phoneNumberFormat"
                                                [slotChar]="'_'" class="w-100"
                                                [autClear]="false"
                                                formControlName="contactWorkPhone"
                                                (input)="updateContactPhonePayload($event, 0)" 
                                                placeholder="{{checkedFields.WorkPhone.labelName}}" 
                                                pTooltip="{{checkedFields.WorkPhone.labelName}}" tooltipPosition="top">
                                            </p-inputMask>
                                            <input *ngIf="!(phoneNumberFormat && !contactPhones[0]?.maskingDisabled)" pInputText type="text" formControlName="contactWorkPhone"
                                            (input)="updateContactPhonePayload($event, 0)" placeholder="{{checkedFields.WorkPhone.labelName}}" 
                                            pTooltip="{{checkedFields.WorkPhone.labelName}}" tooltipPosition="top"/>
                                        </div>

                                        <div class="p-mb-2" *ngIf="hasMaxPhoneLengthError('contactWorkPhone')">
                                            <small class="p-invalid">
                                                Max 50 characters
                                            </small>
                                        </div>
                                        <div class="p-mb-3" *ngIf="hasPatternError('contactWorkPhone')">
                                            <small class="p-invalid">
                                                Invalid phone format
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                <div class="p-grid" *ngIf="checkedFields.HomePhone">
                                    <div class="p-col-12 p-lg-4 ">
                                        <p-dropdown [options]="countryData" [filter]="true" filterBy="CountryName"
                                            optionLabel="CountryName"
                                            optionValue="CountryName"
                                            [autoDisplayFirst]="false"
                                            [(ngModel)]="contactPhones[1].country"
                                            [ngModelOptions]="{standalone: true}"
                                            placeholder="Select Country"
                                            (onChange)="updateContactPhoneCodePayload($event, 1)"
                                            class="inline" appendTo="body">
                                        </p-dropdown>
                                    </div>
                                    <div class="p-col-12 p-lg-8">
                                        <div class="p-inputgroup">
                                            <span class="p-inputgroup-addon">+{{ contactPhones[1].code }}</span>
                                            <p-inputMask
                                                *ngIf="phoneNumberFormat && !contactPhones[1]?.maskingDisabled"
                                                [mask]="phoneNumberFormat"
                                                [slotChar]="'_'"
                                                [autoClear]="false"
                                                formControlName="contactHomePhone"
                                                (input)="updateContactPhonePayload($event, 0)" 
                                                class="w-100" placeholder="{{checkedFields.HomePhone.labelName}}" 
                                                pTooltip="{{checkedFields.HomePhone.labelName}}" tooltipPosition="top">
                                            </p-inputMask>
                                            <input *ngIf="!(phoneNumberFormat && !contactPhones[1]?.maskingDisabled)" pInputText type="text" formControlName="contactHomePhone"
                                            (input)="updateContactPhonePayload($event, 1)" placeholder="{{checkedFields.HomePhone.labelName}}" 
                                            pTooltip="{{checkedFields.HomePhone.labelName}}" tooltipPosition="top" />
                                        </div>

                                        <div class="p-mb-2" *ngIf="hasMaxPhoneLengthError('contactHomePhone')">
                                            <small class="p-invalid">
                                                Max 50 characters
                                            </small>
                                        </div>
                                        <div class="p-mb-3" *ngIf="hasPatternError('contactHomePhone')">
                                            <small class="p-invalid">
                                                Invalid phone format
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                <div class="p-grid" *ngIf="checkedFields.MobilePhone">
                                    <div class="p-col-12 p-lg-4 ">
                                        <p-dropdown [options]="countryData" [filter]="true" filterBy="CountryName"
                                            optionLabel="CountryName"
                                            optionValue="CountryName"
                                            [autoDisplayFirst]="false"
                                            [(ngModel)]="contactPhones[2].country"
                                            [ngModelOptions]="{standalone: true}"
                                            placeholder="Select Country"
                                            (onChange)="updateContactPhoneCodePayload($event, 2)"
                                            class="inline" appendTo="body">
                                        </p-dropdown>
                                    </div>
                                    <div class="p-col-12 p-lg-8">
                                        <div class="p-inputgroup">
                                            <span class="p-inputgroup-addon">+{{ contactPhones[2].code }}</span>
                                            <p-inputMask
                                                *ngIf="phoneNumberFormat && !contactPhones[2]?.maskingDisabled"
                                                [mask]="phoneNumberFormat"
                                                [slotChar]="'_'"
                                                [autoClear]="false"
                                                formControlName="contactMobilePhone"
                                                (input)="updateContactPhonePayload($event, 2)" 
                                                class="w-100" placeholder="{{checkedFields.MobilePhone.labelName}}" 
                                                pTooltip="{{checkedFields.MobilePhone.labelName}}" tooltipPosition="top">
                                            </p-inputMask>
                                            <input *ngIf="!(phoneNumberFormat && !contactPhones[2]?.maskingDisabled)" pInputText type="text" formControlName="contactMobilePhone"
                                            (input)="updateContactPhonePayload($event, 2)" placeholder="{{checkedFields.MobilePhone.labelName}}" 
                                            pTooltip="{{checkedFields.MobilePhone.labelName}}" tooltipPosition="top" />
                                        </div>

                                        <div class="p-mb-2" *ngIf="hasMaxPhoneLengthError('contactMobilePhone')">
                                            <small class="p-invalid">
                                                Max 50 characters
                                            </small>
                                        </div>
                                        <div class="p-mb-3" *ngIf="hasPatternError('contactMobilePhone')">
                                            <small class="p-invalid">
                                                Invalid phone format
                                            </small>
                                        </div>
                                    </div>
                                </div>


                                <div class="p-grid" *ngIf="checkedFields.CP1">
                                    <div class="p-col-12 p-lg-4 ">
                                        <p-dropdown [options]="countryData" [filter]="true" filterBy="CountryName"
                                            optionLabel="CountryName"
                                            optionValue="CountryName"
                                            [autoDisplayFirst]="false"
                                            [(ngModel)]="contactPhones[3].country"
                                            [ngModelOptions]="{standalone: true}"
                                            placeholder="Select Country"
                                            (onChange)="updateContactPhoneCodePayload($event, 3)"
                                            class="inline" appendTo="body">
                                        </p-dropdown>
                                    </div>
                                    <div class="p-col-12 p-lg-8">
                                        <div class="p-inputgroup">
                                            <span class="p-inputgroup-addon">+{{ contactPhones[3].code }}</span>
                                            <p-inputMask
                                                *ngIf="phoneNumberFormat && !contactPhones[3]?.maskingDisabled"
                                                [mask]="phoneNumberFormat"
                                                [slotChar]="'_'"
                                                [autoClear]="false"
                                                formControlName="contactCP1Phone"
                                                (input)="updateContactPhonePayload($event, 3)" 
                                                class="w-100" placeholder="{{checkedFields.CP1.labelName}}" 
                                                pTooltip="{{checkedFields.CP1.labelName}}" tooltipPosition="top">
                                            </p-inputMask>
                                            <input *ngIf="!(phoneNumberFormat && !contactPhones[3]?.maskingDisabled)" pInputText type="text" formControlName="contactCP1Phone"
                                            (input)="updateContactPhonePayload($event, 3)" placeholder="{{checkedFields.CP1.labelName}}" 
                                            pTooltip="{{checkedFields.CP1.labelName}}" tooltipPosition="top" />
                                        </div>

                                        <div class="p-mb-2" *ngIf="hasMaxPhoneLengthError('contactCP1Phone')">
                                            <small class="p-invalid">
                                                Max 50 characters
                                            </small>
                                        </div>
                                        <div class="p-mb-3" *ngIf="hasPatternError('contactCP1Phone')">
                                            <small class="p-invalid">
                                                Invalid phone format
                                            </small>
                                        </div>
                                    </div>
                                </div>

                                <div  class="p-grid" *ngIf="checkedFields.CP2">
                                    <div class="p-col-12 p-lg-4 ">
                                        <p-dropdown [options]="countryData" [filter]="true" filterBy="CountryName"
                                            optionLabel="CountryName"
                                            optionValue="CountryName"
                                            [autoDisplayFirst]="false"
                                            [(ngModel)]="contactPhones[4].country"
                                            [ngModelOptions]="{standalone: true}"
                                            placeholder="Select Country"
                                            (onChange)="updateContactPhoneCodePayload($event, 4)"
                                            class="inline" appendTo="body">
                                        </p-dropdown>
                                    </div>
                                    <div class="p-col-12 p-lg-8">
                                        <div class="p-inputgroup">
                                            <span class="p-inputgroup-addon">+{{ contactPhones[4].code }}</span>
                                            <p-inputMask
                                                *ngIf="phoneNumberFormat && !contactPhones[4]?.maskingDisabled"
                                                [mask]="phoneNumberFormat"
                                                [slotChar]="'_'"
                                                [autoClear]="false"
                                                formControlName="contactCP2Phone"
                                                (input)="updateContactPhonePayload($event, 4)" 
                                                class="w-100" placeholder="{{checkedFields.CP2.labelName}}" 
                                                pTooltip="{{checkedFields.CP2.labelName}}" tooltipPosition="top">
                                            </p-inputMask>
                                            <input *ngIf="!(phoneNumberFormat && !contactPhones[4]?.maskingDisabled)" pInputText type="text" formControlName="contactCP2Phone"
                                            (input)="updateContactPhonePayload($event, 4)" placeholder="{{checkedFields.CP2.labelName}}" 
                                            pTooltip="{{checkedFields.CP2.labelName}}" tooltipPosition="top" />
                                        </div>

                                        <div class="p-mb-2" *ngIf="hasMaxPhoneLengthError('contactCP2Phone')">
                                            <small class="p-invalid">
                                                Max 50 characters
                                            </small>
                                        </div>
                                        <div class="p-mb-3" *ngIf="hasPatternError('contactCP2Phone')">
                                            <small class="p-invalid">
                                                Invalid phone format
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="p-field p-formgrid p-grid multiline p-mt-3">
                            <div class="p-col-12 p-lg-6"
                                *ngIf="checkedFields.ContactTwitter || checkedFields.ContactFacebook
                                || checkedFields.ContactLinkedin || checkedFields.ContactInstagram || checkedFields.ContactWebsite">
                                <div class="p-inputgroup p-mb-2">
                                    <label style="width: 100%;">
                                        {{ checkedFields.SocialProfile?.labelName }}
                                    </label>
                                </div>

                                <div class="p-col-12 p-pl-0" *ngIf="checkedFields.ContactTwitter">
                                    <span class="p-input-icon-left w-100">
                                        <i [pTooltip]="checkedFields.ContactTwitter?.labelName" tooltipPosition="top"
                                            class="fa fa-twitter">
                                        </i>
                                        <input pInputText type="text" (input)="updateContactSocialPayload($event, 0)"
                                            formControlName="contactSocialTwitter" />
                                    </span>
                                    <div class="p-mt-1" *ngIf="hasMaxLengthError('contactSocialTwitter')">
                                        <small class="p-invalid">
                                            Max 500 characters
                                        </small>
                                    </div>
                                </div>

                                <div class="p-col-12 p-pl-0" *ngIf="checkedFields.ContactFacebook">
                                    <span class="p-input-icon-left w-100 p-mt-3">
                                        <i [pTooltip]="checkedFields.ContactFacebook?.labelName" tooltipPosition="top"
                                            class="fa fa-facebook-official">
                                        </i>
                                        <input pInputText type="text" (input)="updateContactSocialPayload($event, 1)"
                                            formControlName="contactSocialFacebook" />
                                    </span>
                                    <div class="p-mt-1" *ngIf="hasMaxLengthError('contactSocialFacebook')">
                                        <small class="p-invalid">
                                            Max 500 characters
                                        </small>
                                    </div>
                                </div>

                                <div class="p-col-12 p-pl-0" *ngIf="checkedFields.ContactLinkedin">
                                    <span class="p-input-icon-left w-100 p-mt-3">
                                        <i [pTooltip]="checkedFields.ContactLinkedin?.labelName" tooltipPosition="top"
                                            class="fa fa-linkedin">
                                        </i>
                                        <input pInputText type="text" (input)="updateContactSocialPayload($event, 2)"
                                            formControlName="contactSocialLinkedIn" />
                                    </span>
                                    <div class="p-mt-1" *ngIf="hasMaxLengthError('contactSocialLinkedIn')">
                                        <small class="p-invalid">
                                            Max 500 characters
                                        </small>
                                    </div>
                                </div>

                                <div class="p-col-12 p-pl-0" *ngIf="checkedFields.ContactInstagram">
                                    <span class="p-input-icon-left w-100 p-mt-3">
                                        <i [pTooltip]="checkedFields.ContactInstagram?.labelName" tooltipPosition="top"
                                            class="fa fa-instagram">
                                        </i>
                                        <input pInputText type="text" (input)="updateContactSocialPayload($event, 3)"
                                            formControlName="contactSocialInstagram" />
                                    </span>
                                    <div class="p-mt-1" *ngIf="hasMaxLengthError('contactSocialInstagram')">
                                        <small class="p-invalid">
                                            Max 500 characters
                                        </small>
                                    </div>
                                </div>

                                <div class="p-col-12 p-pl-0" *ngIf="checkedFields.ContactWebsite">
                                    <span class="p-input-icon-left w-100 p-mt-3">
                                        <i [pTooltip]="checkedFields.ContactWebsite?.labelName" tooltipPosition="top"
                                            class="fa fa-desktop">
                                        </i>
                                        <input pInputText type="text" (input)="updateContactSocialPayload($event, 4)"
                                            formControlName="contactSocialWebsite" />
                                    </span>
                                    <div class="p-mt-1" *ngIf="hasMaxLengthError('contactSocialWebsite')">
                                        <small class="p-invalid">
                                            Max 500 characters
                                        </small>
                                    </div>
                                </div>
                            </div>

                            <div class="p-col-12 p-lg-6" *ngIf="checkedFields.ProfileImage">
                                <label class="p-mb-2">
                                    {{ checkedFields.ProfileImage?.labelName }}
                                </label>
                                <p-fileUpload customUpload="true" class="fupload" previewWidth="100"
                                    chooseLabel="Choose" accept="image/*" [showUploadButton]="false"
                                    invalidFileTypeMessageDetail="Allowed file types: .png .jpg .jpeg .gif"
                                    [showCancelButton]="false" (onSelect)="uploadProfilePic($event.files)">

                                    <ng-template pTemplate="file"></ng-template>

                                    <ng-template pTemplate="content">
                                        <ng-container *ngFor="let profileImg of shownProfileImages; let i = index;">
                                            <div class="p-fileupload-row p-mb-2">
                                                <button pButton icon="fa fa-download" (click)="downloadFile(profileImg.name,
                                                    profileImg.content)" class="p-button-link p-px-0 p-py-0">
                                                </button>
                                                <div>
                                                    <img [src]="profileImg.content" width="100" alt="card" />
                                                </div>
                                                <div>
                                                    {{ profileImg.name }}
                                                </div>
                                                <div>
                                                    {{ profileImg.size | fileSize }}
                                                </div>
                                                <div>
                                                    <button icon="pi pi-times" pButton (click)="removeProfileImg(i)"
                                                        type="button" icon="pi pi-times">
                                                    </button>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </ng-template>
                                </p-fileUpload>
                            </div>
                        </div>

                        <div class="p-field p-formgrid p-grid multiline p-mt-3" *ngIf="checkedFields.ContactDesignation">
                            <div class="p-col-12 p-lg-6">
                                <label class="p-mb-2">
                                    {{ checkedFields.ContactDesignation?.labelName }}
                                </label>
                                <p-dropdown [options]="jobFunctions" formControlName="contactRoleId" filter="true"
                                    optionLabel="name" optionValue="id" placeholder="Select {{ checkedFields.ContactDesignation?.labelName }}" appendTo="body">
                                </p-dropdown>
                            </div>
                        </div>
                        <div class="p-field p-formgrid p-grid multiline p-mt-3" *ngIf="checkedFields.ContactRoles">
                            <div class="p-col-12 p-lg-6">
                                <label class="p-mb-2">
                                    {{ checkedFields.ContactRoles?.labelName }}
                                </label>
                                <p-multiSelect [options]="contactRoles" formControlName="contactJobFunctionIds" filter="true" 
                                    optionLabel="name" placeholder="Select {{ checkedFields.ContactRoles?.labelName }}" appendTo="body">
                                </p-multiSelect>
                            </div>
                        </div>
                    </div>
                </div>

                <p-tabView [(activeIndex)]="tabIndex" *ngIf="isAdd || isEdit || isCopyAccount">
                    <p-tabPanel [header]="templateSections && templateSections[1]?.name">
                        <div class="card p-ml-0" *ngIf="isAdd || isEdit || isCopyAccount; else accountInfoViewBlock">
                            <div class="p-field p-grid">
                                <div class="p-col-12 p-lg-6">
                                    <label class="p-mb-2"> {{ checkedFields.AccountIDNo?.labelName }} <span
                                            style="color: red;">*</span></label>
                                    <input pInputText type="text" formControlName="sequenceNumber" disabled
                                        tooltipPosition="top" pTooltip="
                                Displayed Account ID No. May Appear Different After Saving" />
                                </div>
                                <div class="p-col-6">
                                    <label class="p-mb-2">
                                        {{ checkedFields.AccountName?.labelName }}
                                    </label>
                                    <input pInputText type="text" formControlName="accountName" pattern="^[^:]*$" />
                                    <div class="p-mt-1" *ngIf="hasMaxLengthError('accountName')">
                                        <small class="p-invalid">
                                            Max 100 characters
                                        </small>
                                    </div>
                                    <div class="p-mt-1"
                                        *ngIf="hasValue('accountName') && hasLengthError('accountName')">
                                        <small class="p-invalid">
                                            {{ checkedFields.AccountName?.labelName }} can not be empty.
                                        </small>
                                    </div>
                                    <div class="p-mt-1" *ngIf="hasPatternError('accountName')">
                                        <small class="p-invalid">
                                            Colon (:) is not allowed
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="p-field p-grid">
                                <div class="p-col-12 p-lg-6" *ngIf="checkedFields.ParentAccount">
                                    <label for="parent" class="p-mb-2"> {{ checkedFields.ParentAccount?.labelName }} </label>

                                    <div class="association-name">
                                        <span (click)="openParentAcountDialog()" *ngIf="!selectedParentAccount" class="hyper-link"><strong class="association-name"><i class="pi pi-plus p-mr-2"></i> Select {{ checkedFields.ParentAccount?.labelName }}</strong></span>
                                        <span (click)="openParentAcountDialog()" *ngIf="selectedParentAccount" class="hyper-link">
                                            <strong class="association-name">
                                                <i class="pi pi-pencil p-mr-2"></i>
                                                <ng-container *ngIf="selectedParentAccount?.sequenceNumber">
                                                    {{ selectedParentAccount?.sequenceNumber }} -
                                                </ng-container>
                                                {{ selectedParentAccount?.businessName }}
                                            </strong>
                                            <i (click)="removeParentAccount()" class="pi pi-times p-ml-3"></i>
                                        </span>
                                    </div>

                                    <!-- <p-autoComplete #parent [suggestions]="parentAccounts"
                                        [(ngModel)]="selectedParentAccount" name="parent"
                                        placeholder="Search Parent Account..." field="name" [completeOnFocus]="true"
                                        (completeMethod)="searchParentAccounts($event)" id="parent" appendTo="body"
                                        [forceSelection]="true"
                                        (ngModelChange)="changeParrentAccount()"
                                        dataKey="id" inputId="parent" name="selectedParentAccount"
                                        [ngModelOptions]="{standalone: true}" [disabled]="!isEdit"
                                        (onSelect)="accountExistMsg = '';">
                                    </p-autoComplete> -->
                                    <small *ngIf="accountExistMsg.length" class="p-invalid account-not-exists">
                                        {{ accountExistMsg }}
                                    </small>
                                </div>
                            </div>

                            <div class="p-field p-grid" *ngIf="checkedFields.AccountOwner">
                                <div class="p-col-12 p-lg-6">
                                    <label class="p-mb-2">
                                        {{ checkedFields.AccountOwner?.labelName }} <span style="color: red;">*</span>
                                    </label>
                                    <p-dropdown [options]="activeUsers" formControlName="ownerId" optionLabel="name"
                                        placeholder="Select Account Owner" [filter]="true" [filterBy]="'name'"
                                        appendTo="body">
                                    </p-dropdown>
                                </div>
                            </div>

                            <div class="p-field p-grid"
                                *ngIf="checkedFields.AccountType || checkedFields.AccountNumber">
                                <div class="p-col-12 p-lg-6" *ngIf="checkedFields.AccountType">
                                    <label for="accountTypes" class="p-mb-2">
                                        {{ checkedFields.AccountType?.labelName }}
                                    </label>
                                    <p-multiSelect [options]="accountTypes" placeholder="Select Account Type(s)..."
                                        formControlName="accountTypeIds" optionLabel="name" appendTo="body">
                                    </p-multiSelect>
                                </div>
                                <div class="p-col-6" *ngIf="checkedFields.AccountNumber">
                                    <label class="p-mb-2"> {{ checkedFields.AccountNumber?.labelName }} </label>
                                    <input pInputText type="text" formControlName="accountNumber" />
                                    <div class="p-mt-1">
                                        <small *ngIf="hasMaxLengthError('accountNumber')" class="p-invalid">
                                            Max 50 characters
                                        </small>
                                    </div>
                                </div>
                            </div>

                            <div class="p-field p-grid" *ngIf="checkedFields.Timezone || checkedFields.Currency">
                                <div class="p-col-12 p-lg-6" *ngIf="checkedFields.Timezone">
                                    <label class="p-mb-2">
                                        {{ checkedFields.Timezone?.labelName }}
                                    </label>
                                    <p-dropdown [options]="timezones" placeholder="Select Timezone..."
                                        formControlName="timezoneId" optionLabel="name" [filter]="true"
                                        [filterBy]="'name'" appendTo="body">
                                    </p-dropdown>
                                </div>
                                <div class="p-col-12 p-lg-6" *ngIf="checkedFields.Currency">
                                    <label class="p-mb-2">
                                        {{ checkedFields.Currency?.labelName }}
                                    </label>
                                    <p-dropdown [options]="currencies" placeholder="Select Currency..."
                                        formControlName="currencyId" optionLabel="name" [filter]="true"
                                        [filterBy]="'name'" appendTo="body">
                                    </p-dropdown>
                                </div>
                            </div>

                            <div *ngIf="checkedFields.Tags" class="p-field p-grid">
                                <div class="p-col-12">
                                    <label>Tags
                                        <!-- <span class="btnBars" (click)="isEditTag = !isEditTag"><i
                                                class="pi pi-pencil"></i></span> -->
                                        <span class="btnBars" (click)="addTag()"><i class="pi pi-plus"></i></span>
                                    </label>
                                    <ng-container *ngFor="let s of tags; let i = index">
                                        <p-tag class="p-ml-2" [style]="{'background-color': s.color}">
                                            <div style="display: flex;padding: 2px;" (click)="removeTag(i)">
                                                <div>{{s.name}}</div>
                                                <div class="crossIconAlignment"><i style="font-size: 8px;" class="pi pi-times"></i></div>
                                            </div>
                                        </p-tag>
                                        <!-- <span class="btnBars" (click)="removeTag(i)" *ngIf="isEditTag">
                                            <i class="pi pi-trash"></i>
                                        </span> -->
                                    </ng-container>
                                </div>
                            </div>

                            <app-shared-custom-fields [customForm]="accountInfoCustomForm" [isEdit]="isEdit"
                                [templateCustomFields]="templateSections[1]?.customFields"
                                [isTouched]="isChildFormTouched" (setCustomFieldValue)="setCustomFieldValue($event)"
                                [isCopy]="isCopyAccount" [customFieldValues]="dataForCopy?.customAttributeValues">
                            </app-shared-custom-fields>
                        </div>
                    </p-tabPanel>

                    <p-tabPanel [header]="templateSections && templateSections[2]?.name">
                        <div class="card">
                            <div class="p-field p-grid" *ngIf="checkedFields.DoingBusinessas || checkedFields.TaxID">
                                <div class="p-col-12 p-lg-6" *ngIf="checkedFields.DoingBusinessas
                                ">
                                    <label class="p-mb-2">
                                        {{ checkedFields.DoingBusinessas?.labelName }}
                                    </label>
                                    <input pInputText type="text" formControlName="doingBusinessAs" />
                                    <div class="p-mt-1" *ngIf="hasMaxLengthError('doingBusinessAs')">
                                        <small class="p-invalid">
                                            Max 50 characters
                                        </small>
                                    </div>
                                </div>
                                <div class="p-col-12 p-lg-6" *ngIf="checkedFields.TaxID">
                                    <label class="p-mb-2">
                                        {{ checkedFields.TaxID?.labelName }}
                                    </label>
                                    <input pInputText type="text" formControlName="taxId" />
                                    <div class="p-mt-1" *ngIf="hasMaxLengthError('taxId')">
                                        <small class="p-invalid">
                                            Max 50 characters
                                        </small>
                                    </div>
                                </div>
                            </div>

                            <div class="p-field p-grid"
                                *ngIf="checkedFields.NumberofEmployees || checkedFields.EstimatedAnnualRevenue">
                                <div class="p-col-12 p-lg-6" *ngIf="checkedFields.NumberofEmployees">
                                    <label class="p-mb-2">
                                        {{ checkedFields.NumberofEmployees?.labelName }}
                                    </label>
                                    <p-dropdown [options]="employeeCount" placeholder="Select Employees..."
                                        formControlName="numberOfEmployeesId" optionLabel="name" [filter]="true"
                                        [filterBy]="'name'" appendTo="body">
                                    </p-dropdown>
                                </div>
                                <div class="p-col-12 p-lg-6" *ngIf="checkedFields.EstimatedAnnualRevenue">
                                    <label for="annualRevenue" class="p-mb-2">
                                        {{ checkedFields.EstimatedAnnualRevenue?.labelName }}
                                    </label>
                                    <p-dropdown [options]="revenues" placeholder="Select Revenue..."
                                        formControlName="annualRevenueId" optionLabel="name" [filter]="true"
                                        [filterBy]="'name'" appendTo="body">
                                    </p-dropdown>
                                </div>
                            </div>

                            <div class="p-field p-grid"
                                *ngIf="checkedFields.OwnershipType || checkedFields.CurrentCategory">
                                <div class="p-col-12 p-lg-6" *ngIf="checkedFields.OwnershipType">
                                    <label class="p-mb-2">
                                        {{ checkedFields.OwnershipType?.labelName }}
                                    </label>
                                    <p-dropdown [options]="ownerships" placeholder="Select Ownership..."
                                        formControlName="ownershipTypeId" optionLabel="name" [filter]="true"
                                        filterBy="name" appendTo="body">
                                    </p-dropdown>
                                </div>
                                <div class="p-col-12 p-lg-6" *ngIf="checkedFields.CurrentCategory">
                                    <label class="p-mb-2">
                                        {{ checkedFields.CurrentCategory?.labelName }}
                                    </label>
                                    <p-dropdown [options]="stages" placeholder="Select Current Category..."
                                        formControlName="stageId" optionLabel="name" [filter]="true" [filterBy]="'name'"
                                        appendTo="body" (onChange)="setStageOwnerAccordingToStage($event.value)">
                                    </p-dropdown>
                                    <div class="p-mt-2" *ngIf="isInvalid('stageId')">
                                        <small class="p-invalid details-error">
                                            Please select {{ checkedFields.CurrentCategory?.labelName }}
                                        </small>
                                    </div>
                                </div>
                            </div>

                            <div class="p-field p-grid" *ngIf="accountOwnerSettings?.enabled">
                                <div class="p-col-12 p-lg-6">
                                    <label for="name">Stage Owner</label>
                                    <p-dropdown [options]="activeUsers" placeholder="Select lead stage Owner" inputId="stageOwnerId"
                                        formControlName="stageOwnerId" optionLabel="name" optionValue="id" [filter]="true" [filterBy]="'name'"
                                        appendTo="body">
                                    </p-dropdown>
                                </div>
                            </div>

                            <div class="p-field p-grid" *ngIf="checkedFields.FoundedYear || checkedFields.Industry">
                                <div class="p-col-12 p-lg-6" *ngIf="checkedFields.FoundedYear">
                                    <label class="p-mb-2">
                                        {{ checkedFields.FoundedYear?.labelName }}
                                    </label>
                                    <input pInputText type="text" formControlName="foundedYear" />
                                    <div class="p-mt-1" *ngIf="hasMaxLengthError('foundedYear')">
                                        <small class="p-invalid">
                                            Max 15 digits
                                        </small>
                                    </div>
                                </div>
                                <div class="p-col-12 p-lg-6" *ngIf="checkedFields.Industry">
                                    <label class="p-mb-2">
                                        {{ checkedFields.Industry?.labelName }}
                                    </label>
                                    <p-dropdown [options]="industries" formControlName="industryId"
                                        placeholder="Select Industry..." optionLabel="name" [filter]="true"
                                        [filterBy]="'name'" appendTo="body">
                                    </p-dropdown>
                                </div>
                            </div>

                            <div class="p-field p-grid p-mb-0"
                                *ngIf="checkedFields.AccountEmail || checkedFields.AccountPhone">
                                <div class="p-col-6" *ngIf="checkedFields.AccountEmail">
                                    <label class="p-mb-2">
                                        {{ checkedFields.AccountEmail?.labelName }}
                                    </label>
                                    <div>
                                        <span class="p-input-icon-left w-100">
                                            <i [pTooltip]="checkedFields.AccountWorkEmail?.labelName"
                                                tooltipPosition="top" class="pi pi-envelope"></i>
                                            <input pInputText type="email" formControlName="accountEmail"
                                                pattern="[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$" />
                                        </span>
                                        <div class="p-mt-2" *ngIf="isInvalid('accountEmail')">
                                            <div *ngIf="hasMaxLengthError('accountEmail')">
                                                <small class="p-invalid details-error">
                                                    Max 100 characters
                                                </small>
                                            </div>
                                            <div *ngIf="hasPatternError('accountEmail')">
                                                <small class="p-invalid details-error">
                                                    Invalid email format
                                                </small>
                                            </div>
                                            <div *ngIf="hasEmailExistError('accountEmail')">
                                                <small class="p-invalid details-error">
                                                    This email already added, please enter another email
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="p-col-6 p-pt-1" *ngIf="checkedFields.AccountPhone">
                                    <div class="p-grid">
                                        <div class="p-col-12 p-lg-4">
                                            <label class="p-mb-2">Select Country</label>
                                            <p-dropdown [options]="countryData" [filter]="true" filterBy="CountryName"
                                                optionLabel="CountryName"
                                                optionValue="CountryName"
                                                [autoDisplayFirst]="false"
                                                formControlName="accountPhoneCountry"
                                                placeholder="Select Country"
                                                (onChange)="onSelectAccountPhoneCountry($event)"
                                                class="inline" appendTo="body">
                                            </p-dropdown>
                                        </div>
                                        <div class="p-col-12 p-lg-6">
                                            <label class="p-mb-2">
                                                {{ checkedFields.AccountPhone?.labelName }}
                                            </label>
                                            <div class="p-inputgroup">
                                                <span class="p-inputgroup-addon">+{{accountForm.getRawValue().accountPhoneCode}}</span>
                                                <p-inputMask *ngIf="phoneNumberFormat && !accountPhoneMaskingDisabled" [mask]="phoneNumberFormat" formControlName="accountPhone" [slotChar]="'_'" [autoClear]="false"></p-inputMask>
                                                <input *ngIf="!(phoneNumberFormat && !accountPhoneMaskingDisabled)" pInputText type="text" formControlName="accountPhone" />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="p-mb-2" *ngIf="hasMaxPhoneLengthError('accountPhone')">
                                        <small class="p-invalid details-error">
                                            Max 50 characters
                                        </small>
                                    </div>
                                    <div class="p-mb-3" *ngIf="hasPatternError('accountPhone')">
                                        <small class="p-invalid details-error">
                                            Invalid phone format
                                        </small>
                                    </div>
                                </div>
                            </div>

                            <div class="p-field p-grid p-mb-3 p-mt-3" *ngIf="checkedFields.AccountWebsite
                                || checkedFields.AccountTwitter">
                                <div class="p-col-12 p-lg-6" *ngIf="checkedFields.AccountWebsite">
                                    <label class="p-mb-2">
                                        {{ checkedFields.AccountWebsite?.labelName }}
                                    </label>
                                    <input pInputText type="text" formControlName="accountSocialWebsite"
                                        placeholder="URL" />
                                    <div class="p-mt-2 p-mb-2" *ngIf="hasMaxLengthError('accountSocialWebsite')">
                                        <small class="p-invalid">
                                            Max 500 characters
                                        </small>
                                    </div>
                                </div>
                                <div class="p-col-12 p-lg-6" *ngIf="checkedFields.AccountTwitter">
                                    <label class="p-mb-2">
                                        {{ checkedFields.AccountTwitter?.labelName }}
                                    </label>
                                    <input pInputText type="text" formControlName="accountSocialTwitter"
                                        placeholder="URL" />
                                    <div class="p-mt-2 p-mb-2" *ngIf="hasMaxLengthError('accountSocialTwitter')">
                                        <small class="p-invalid">
                                            Max 500 characters
                                        </small>
                                    </div>
                                </div>
                            </div>

                            <div class="p-field p-grid p-mb-3" *ngIf="checkedFields.AccountFacebook
                                || checkedFields.AccountLinkedin">
                                <div class="p-col-12 p-lg-6" *ngIf="checkedFields.AccountFacebook">
                                    <label class="p-mb-2">
                                        {{ checkedFields.AccountFacebook?.labelName }}
                                    </label>
                                    <input pInputText type="text" formControlName="accountSocialFacebook"
                                        placeholder="URL" />
                                    <div class="p-mt-2 p-mb-2" *ngIf="hasMaxLengthError('accountSocialFacebook')">
                                        <small class="p-invalid">
                                            Max 500 characters
                                        </small>
                                    </div>
                                </div>
                                <div class="p-col-12 p-lg-6" *ngIf="checkedFields.AccountLinkedin">
                                    <label class="p-mb-2">
                                        {{ checkedFields.AccountLinkedin?.labelName }}
                                    </label>
                                    <input pInputText type="text" formControlName="accountSocialLinkedIn"
                                        placeholder="URL" />
                                    <div class="p-mt-2 p-mb-2" *ngIf="hasMaxLengthError('accountSocialLinkedIn')">
                                        <small class="p-invalid">
                                            Max 500 characters
                                        </small>
                                    </div>
                                </div>
                            </div>

                            <div class="p-field p-grid p-mb-3" *ngIf="checkedFields.AccountInstagram">
                                <div class="p-col-12 p-lg-6">
                                    <label class="p-mb-2">
                                        {{ checkedFields.AccountInstagram?.labelName }}
                                    </label>
                                    <input pInputText type="text" formControlName="accountSocialInstagram"
                                        placeholder="URL" />
                                    <div class="p-mt-2 p-mb-2" *ngIf="hasMaxLengthError('accountSocialInstagram')">
                                        <small class="p-invalid">
                                            Max 500 characters
                                        </small>
                                    </div>
                                </div>
                            </div>

                            <div class="p-field p-grid" *ngIf="checkedFields.SICCode || checkedFields.NAICSCode">
                                <div class="p-col-12 p-lg-6" *ngIf="checkedFields.SICCode">
                                    <label class="p-mb-2">
                                        {{ checkedFields.SICCode?.labelName }}
                                    </label>
                                    <input pInputText type="text" formControlName="sicCode" />
                                </div>
                                <div class="p-col-12 p-lg-6" *ngIf="checkedFields.NAICSCode">
                                    <label class="p-mb-2">
                                        {{ checkedFields.NAICSCode?.labelName }}
                                    </label>
                                    <input pInputText type="text" formControlName="naicsCode" />
                                </div>
                            </div>

                            <div class="p-field p-grid" *ngIf="checkedFields.AccountSource || checkedFields.Rating">
                                <div class="p-col-12 p-lg-6" *ngIf="checkedFields.AccountSource">
                                    <label class="p-mb-2">
                                        {{ checkedFields.AccountSource?.labelName }}
                                    </label>
                                    <p-dropdown [options]="accountSources" placeholder="Select Account Source..."
                                        optionLabel="name" formControlName="accountSourceId" [filter]="true"
                                        [filterBy]="'name'" appendTo="body">
                                    </p-dropdown>
                                </div>
                                <div class="p-col-12 p-lg-6" *ngIf="checkedFields.Rating">
                                    <label class="p-mb-2">
                                        {{ checkedFields.Rating?.labelName }}
                                    </label>
                                    <p-dropdown [options]="ratings" placeholder="Select Rating..."
                                        formControlName="ratingId" optionLabel="name" [filter]="true"
                                        [filterBy]="'name'" appendTo="body">
                                    </p-dropdown>
                                </div>
                            </div>

                            <div class="p-field p-grid" *ngIf="checkedFields.Notes">
                                <div class="p-col-12">
                                    <label> {{ checkedFields.Notes?.labelName }} </label>
                                    <textarea pInputTextarea type="text" formControlName="notes"></textarea>
                                </div>
                            </div>

                            <app-shared-custom-fields [customForm]="accountDetailsCustomForm" [isEdit]="isEdit"
                                [templateCustomFields]="templateSections[2]?.customFields"
                                [isTouched]="isChildFormTouched" (setCustomFieldValue)="setCustomFieldValue($event)"
                                [isCopy]="isCopyAccount" [customFieldValues]="dataForCopy?.customAttributeValues"
                                [isSubmitted]="isSubmitted" [tabIndex]="1">
                            </app-shared-custom-fields>
                        </div>
                    </p-tabPanel>

                    <p-tabPanel [header]="templateSections && templateSections[3]?.name">
                        <app-lion-address-grid [moduleId]="accountModuleId" [checkedFields]="checkedFields"
                            [addressList]="accountTempAddress" [countries]="countries"
                            [contactListAttn]="contactListAttn" [selectedObjectRecord]="selectedAccount"
                            [allowEdit]="isEdit" [accountAddressTypes]="addressTypes" [addressClasses]="addressClasses"
                            [accountName]="accountForm.get('accountName').value"
                            [firstName]="accountForm.get('contactFirstName').value"
                            [lastName]="accountForm.get('contactLastName').value"
                            mappingField="accountId" [overViewPage]="false" (onUpdateAddressList)="onUpdateAddressList($event)">
                        </app-lion-address-grid>
                    </p-tabPanel>


                    <!-- Custom Section -->
                    <ng-container *ngFor="let customSection of customSections; let i = index">
                        <p-tabPanel *ngIf="customSection && customSection?.customFields?.length > 0" [header]="customSection?.name">
                            <app-shared-custom-fields
                                [customForm]="customSectionsForm[i]"
                                [isEdit]="isEdit"
                                [templateCustomFields]="customSection?.customFields"
                                [isTouched]="isChildFormTouched"
                                [isCopy]="isCopyAccount"
                                [customFieldValues]="dataForCopy?.customAttributeValues"
                                [isSubmitted]="isSubmitted"
                                [sectionId]="customSection.id"
                                [tabIndex]="(3+i)"
                                (setCustomFieldValue)="setCustomSectionFieldValue($event)">
                            </app-shared-custom-fields>
                        </p-tabPanel>
                    </ng-container>
                    <!-- End Custom Section -->



                    <!-- <p-tabPanel header="Communication Pref.">
                        <p-table [value]="communication" responsiveLayout="scroll">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th></th>
                                    <th>Subscription</th>
                                    <th>Unsubscription</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-product>
                                <tr>
                                    <td>{{product.name}}</td>
                                    <td [class.action] = "product.name !== 'SMS' && product.name !== 'WhatsApp'">
                                        <ng-container *ngIf="product.name === 'SMS' || product.name === 'WhatsApp'">
                                            <span class="pi pi-check" style="color: #7be959;" *ngIf="product.isSubscrib"></span>
                                            <span class="pi pi-times" *ngIf="!product.isSubscrib"></span>
                                        </ng-container>
                                        <ng-container *ngIf="product.name !== 'SMS' && product.name !== 'WhatsApp'">
                                            <p-checkbox [(ngModel)]="product.isSubscrib" [binary]="true" inputId="binary"
                                            (onChange)="changeSubscrib($event,product)" [ngModelOptions]="{standalone: true}"></p-checkbox>
                                        </ng-container>
                                    </td>
                                    <td>
                                        <span class="pi pi-check" style="color: #7be959;" *ngIf="product.unSubscrib"></span>
                                        <span class="pi pi-times" *ngIf="!product.unSubscrib"></span>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </p-tabPanel> -->
                </p-tabView>
            </form>
        </div>
    </div>

    <ng-template #elseBlock style="font-size: 14px">
        {{ noTemplateMessage }}
    </ng-template>

    <p-footer>
        <button type="button" pButton (click)="onCloseAddEditView()" label="Cancel" class="p-button-secondary"></button>
        <button *ngIf="isEdit && !noTemplateMessage.length" type="submit" pButton (click)="verifySubmit('view')"
            label="Save & View"></button>
        <button *ngIf="isEdit && !noTemplateMessage.length" type="submit" pButton (click)="verifySubmit('save')"
            label="Save">
        </button>
    </p-footer>
</p-dialog>

<!-- Show tag list table -->
<ng-container *ngIf="displayAddTag">
    <app-assign-tag-dialog
        [showDialog]="displayAddTag"
        [selectedTags]="selectedValues"
        [tagList]="tagList"
        (assignedTag)="assignSelectedTags($event)"
        (addNewTag)="displayCreateTag = true"
        (closed)="displayAddTag = false">
    </app-assign-tag-dialog>
</ng-container>

<!-- Show add new tag dialog-->
<ng-container *ngIf="displayCreateTag">
    <app-add-tag-dialog
        [showDialog]="displayCreateTag"
        (clickSubmit)="createTag($event)"
        (closed)="displayCreateTag = false">
    </app-add-tag-dialog>
</ng-container>

<app-shared-manual-modal [displayPopup]="displayManualPopup"
    [colsList]="manualRuleColumnSetttings" [singleSelection]="true" [selectedObjectType]="selectedModule"
    [selectedTemplateType]="selectedChannel" [selectedAccount]="selectedRecordList"
    (saveAssignDataclicked)="saveParentAccount($event)" (cancelClicked)="manualpopupCancelClicked()"
    (saveSettingClicked)="columnSettingSaved($event)">
</app-shared-manual-modal>
